// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Measure overlay. Positions come from CSS variables set in measureOverlay.ts:
 *   --pos     guide position (px)          --length  ruler length (px)
 *   --hit     guide grab-strip width (px)  --grip    ruler resize-grip size (px)
 * --hit / --grip are larger on touch devices.
 */
.PupJHrr1baeo8RAS43rK {
  /* Below the Figma overlay (…646) and the panel overlay (…647). */
  position: fixed;
  inset: 0;
  z-index: 2147483645;
  /* Click-through; only the handles opt back in. */
  pointer-events: none;
  /* Without this, a ruler dragged past the edge grows the page and DevTools "fit" emulation zooms everything. */
  overflow: hidden;
  font: 500 11px/1 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
.gsRFg2sqw_JginY7NJm5 {
  position: absolute;
  inset: 0;
}
.VmSJmXF0BXmnm6KBa0K2 {
  position: absolute;
  pointer-events: none;
  padding: 2px 5px;
  border-radius: 3px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  background: #23272f;
  color: #f6f7f9;
}
.irW8vUrs8dGoupUjjuDY {
  background: transparent;
  color: inherit;
  border: 0;
  cursor: pointer;
  font: 600 13px/1 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  padding: 3px 6px;
}
/* ── Ruler ──────────────────────────────────────────── */
.J5s8ld23dhszPqM5B4Bp {
  position: absolute;
  pointer-events: auto;
  touch-action: none;
  cursor: move;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 2px 8px rgba(0, 0, 0, 0.25);
  /* While a drag is snapped: same 1px edge as the normal shadow, just green — no extra border over the edge. */
  /* Selection is marked on the toolbar only — a ring on the ruler would hide the edge being measured. */
}
.J5s8ld23dhszPqM5B4Bp canvas {
  display: block;
}
.J5s8ld23dhszPqM5B4Bp.hHDqP2PuHhH7D_1f2Wqp {
  box-shadow: 0 0 0 1px #22c55e, 0 2px 8px rgba(0, 0, 0, 0.25);
}
.J5s8ld23dhszPqM5B4Bp.QVbg_ANmub302CvsqmMV .Ow3Zt9_8rgicyPwVqTyl {
  box-shadow: 0 0 0 2px #fff;
}
.Ow3Zt9_8rgicyPwVqTyl {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 4px 2px 8px;
  border-radius: 4px;
  pointer-events: auto;
  user-select: none;
  cursor: default;
}
.aK1xXF5pIjwxuHtnKm7m {
  min-width: 96px;
}
/* Red line where the pointer projects onto the ruler. */
.owjDYfn0Qwnw0sc1U4oc {
  position: absolute;
  display: none;
  background: #dc2626;
  pointer-events: none;
}
.lUKSn8H_yTEFQYHdjv98 {
  position: absolute;
  pointer-events: auto;
  touch-action: none;
  background: #23272f;
  border-radius: 3px;
}
/* Cross size = the ruler's thickness (set inline from RULER_THICKNESS). */
.nQQKDucHzj9arggHu5G6 > .owjDYfn0Qwnw0sc1U4oc {
  top: 0;
  width: 1px;
  height: 100%;
}
.nQQKDucHzj9arggHu5G6 > .lUKSn8H_yTEFQYHdjv98 {
  left: calc(var(--length) + 2px);
  top: 0;
  width: var(--grip);
  height: 100%;
  cursor: ew-resize;
}
.iJQRqoFYcwMGmxIjrEQ1 > .owjDYfn0Qwnw0sc1U4oc {
  left: 0;
  width: 100%;
  height: 1px;
}
.iJQRqoFYcwMGmxIjrEQ1 > .lUKSn8H_yTEFQYHdjv98 {
  left: 0;
  top: calc(var(--length) + 2px);
  width: 100%;
  height: var(--grip);
  cursor: ns-resize;
}
/* ── Guides ─────────────────────────────────────────── */
.v6QKX1LFfHe8YUQU8Mit {
  --color: #ff2d9b;
  position: absolute;
  inset: 0;
  pointer-events: none;
  /* Selection is marked on the badge only — a ring on the line would hide what it's aligned with. */
}
.v6QKX1LFfHe8YUQU8Mit.uFMBHgfriC3qM3u2yMcd {
  --color: #0ea5e9;
}
.v6QKX1LFfHe8YUQU8Mit.hHDqP2PuHhH7D_1f2Wqp {
  --color: #22c55e;
}
.v6QKX1LFfHe8YUQU8Mit.QVbg_ANmub302CvsqmMV .L4ztHnerdSVin63hm73G {
  box-shadow: 0 0 0 2px #fff;
}
.v6QKX1LFfHe8YUQU8Mit.iJQRqoFYcwMGmxIjrEQ1 .LK9ZX5dd7Zvsx329DPcz {
  top: 0;
  bottom: 0;
  width: 1px;
  left: calc(var(--pos) - 0.5px);
}
.v6QKX1LFfHe8YUQU8Mit.iJQRqoFYcwMGmxIjrEQ1 .AhNYJ1JRK19McDKdcMUJ {
  top: 0;
  bottom: 0;
  width: var(--hit);
  left: calc(var(--pos) - var(--hit) / 2);
}
.v6QKX1LFfHe8YUQU8Mit.iJQRqoFYcwMGmxIjrEQ1 .L4ztHnerdSVin63hm73G {
  top: 4px;
  left: calc(var(--pos) + 4px);
}
.v6QKX1LFfHe8YUQU8Mit.iJQRqoFYcwMGmxIjrEQ1 .AhNYJ1JRK19McDKdcMUJ,
.v6QKX1LFfHe8YUQU8Mit.iJQRqoFYcwMGmxIjrEQ1 .L4ztHnerdSVin63hm73G {
  cursor: ew-resize;
}
.v6QKX1LFfHe8YUQU8Mit.nQQKDucHzj9arggHu5G6 .LK9ZX5dd7Zvsx329DPcz {
  left: 0;
  right: 0;
  height: 1px;
  top: calc(var(--pos) - 0.5px);
}
.v6QKX1LFfHe8YUQU8Mit.nQQKDucHzj9arggHu5G6 .AhNYJ1JRK19McDKdcMUJ {
  left: 0;
  right: 0;
  height: var(--hit);
  top: calc(var(--pos) - var(--hit) / 2);
}
.v6QKX1LFfHe8YUQU8Mit.nQQKDucHzj9arggHu5G6 .L4ztHnerdSVin63hm73G {
  left: 4px;
  top: calc(var(--pos) + 4px);
}
.v6QKX1LFfHe8YUQU8Mit.nQQKDucHzj9arggHu5G6 .AhNYJ1JRK19McDKdcMUJ,
.v6QKX1LFfHe8YUQU8Mit.nQQKDucHzj9arggHu5G6 .L4ztHnerdSVin63hm73G {
  cursor: ns-resize;
}
.LK9ZX5dd7Zvsx329DPcz {
  position: absolute;
  background: var(--color);
}
/* Wider invisible strip along the line, so it's easy to grab. */
.AhNYJ1JRK19McDKdcMUJ {
  position: absolute;
  pointer-events: auto;
  touch-action: none;
}
.L4ztHnerdSVin63hm73G {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 2px 2px 6px;
  background: var(--color);
  color: #fff;
  pointer-events: auto;
  touch-action: none;
  user-select: none;
}
.L4ztHnerdSVin63hm73G .irW8vUrs8dGoupUjjuDY {
  padding: 1px 5px;
}
/* The element a drag is currently snapped to. */
.sAygrgj8Daa9wqEm3qmV {
  position: absolute;
  outline: 1px dashed #22c55e;
  pointer-events: none;
}
/* Dashed line between two parallel guides (the width of one side is set inline). */
.NrCVGtHQJ3FVdxHbXoTl {
  position: absolute;
  border: 0 dashed #ff2d9b;
}
/* ── Alignment ──────────────────────────────────────── */
.yRL82t8HB2kYAjgLgpF2 {
  position: absolute;
  outline: 1px solid #22c55e;
  background: rgba(34, 197, 94, 0.08);
}
.yRL82t8HB2kYAjgLgpF2.K2iP9598U13usSC8tsyt {
  outline-color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}
.VmSJmXF0BXmnm6KBa0K2.K2iP9598U13usSC8tsyt {
  padding: 1px 4px;
  background: #ef4444;
  color: #fff;
}
/* ── Wrap element ───────────────────────────────────── */
.IBe3QC1B0Cm9WHpC3zQq {
  position: absolute;
  display: none;
  outline: 1px dashed #a855f7;
  background: rgba(168, 85, 247, 0.08);
}
.VmSJmXF0BXmnm6KBa0K2.FtqOHNz1D0yuX9dDydaW {
  display: none;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 10px;
  background: #a855f7;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/features/qaPanel/measure/styles/measureOverlay.module.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,iEAAiE;EACjE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,iDAAiD;EACjD,oBAAoB;EACpB,8GAA8G;EAC9G,gBAAgB;EAChB,0EAA0E;AAC5E;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,eAAe;EACf,0EAA0E;EAC1E,gBAAgB;AAClB;AACA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,wEAAwE;EACxE,6GAA6G;EAC7G,sGAAsG;AACxG;AACA;EACE,cAAc;AAChB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA,0EAA0E;AAC1E;EACE,MAAM;EACN,UAAU;EACV,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,MAAM;EACN,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,WAAW;EACX,WAAW;AACb;AACA;EACE,OAAO;EACP,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,kGAAkG;AACpG;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,QAAQ;EACR,4BAA4B;AAC9B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,wBAAwB;EACxB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/*\n * Measure overlay. Positions come from CSS variables set in measureOverlay.ts:\n *   --pos     guide position (px)          --length  ruler length (px)\n *   --hit     guide grab-strip width (px)  --grip    ruler resize-grip size (px)\n * --hit / --grip are larger on touch devices.\n */\n.root {\n  /* Below the Figma overlay (…646) and the panel overlay (…647). */\n  position: fixed;\n  inset: 0;\n  z-index: 2147483645;\n  /* Click-through; only the handles opt back in. */\n  pointer-events: none;\n  /* Without this, a ruler dragged past the edge grows the page and DevTools \"fit\" emulation zooms everything. */\n  overflow: hidden;\n  font: 500 11px/1 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n.layer {\n  position: absolute;\n  inset: 0;\n}\n.label {\n  position: absolute;\n  pointer-events: none;\n  padding: 2px 5px;\n  border-radius: 3px;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n  background: #23272f;\n  color: #f6f7f9;\n}\n.icon {\n  background: transparent;\n  color: inherit;\n  border: 0;\n  cursor: pointer;\n  font: 600 13px/1 -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  padding: 3px 6px;\n}\n/* ── Ruler ──────────────────────────────────────────── */\n.ruler {\n  position: absolute;\n  pointer-events: auto;\n  touch-action: none;\n  cursor: move;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35), 0 2px 8px rgba(0, 0, 0, 0.25);\n  /* While a drag is snapped: same 1px edge as the normal shadow, just green — no extra border over the edge. */\n  /* Selection is marked on the toolbar only — a ring on the ruler would hide the edge being measured. */\n}\n.ruler canvas {\n  display: block;\n}\n.ruler.snapped {\n  box-shadow: 0 0 0 1px #22c55e, 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n.ruler.selected .toolbar {\n  box-shadow: 0 0 0 2px #fff;\n}\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 4px 2px 8px;\n  border-radius: 4px;\n  pointer-events: auto;\n  user-select: none;\n  cursor: default;\n}\n.readout {\n  min-width: 96px;\n}\n/* Red line where the pointer projects onto the ruler. */\n.marker {\n  position: absolute;\n  display: none;\n  background: #dc2626;\n  pointer-events: none;\n}\n.grip {\n  position: absolute;\n  pointer-events: auto;\n  touch-action: none;\n  background: #23272f;\n  border-radius: 3px;\n}\n/* Cross size = the ruler's thickness (set inline from RULER_THICKNESS). */\n.horizontal > .marker {\n  top: 0;\n  width: 1px;\n  height: 100%;\n}\n.horizontal > .grip {\n  left: calc(var(--length) + 2px);\n  top: 0;\n  width: var(--grip);\n  height: 100%;\n  cursor: ew-resize;\n}\n.vertical > .marker {\n  left: 0;\n  width: 100%;\n  height: 1px;\n}\n.vertical > .grip {\n  left: 0;\n  top: calc(var(--length) + 2px);\n  width: 100%;\n  height: var(--grip);\n  cursor: ns-resize;\n}\n/* ── Guides ─────────────────────────────────────────── */\n.guide {\n  --color: #ff2d9b;\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  /* Selection is marked on the badge only — a ring on the line would hide what it's aligned with. */\n}\n.guide.wrap {\n  --color: #0ea5e9;\n}\n.guide.snapped {\n  --color: #22c55e;\n}\n.guide.selected .badge {\n  box-shadow: 0 0 0 2px #fff;\n}\n.guide.vertical .line {\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  left: calc(var(--pos) - 0.5px);\n}\n.guide.vertical .hit {\n  top: 0;\n  bottom: 0;\n  width: var(--hit);\n  left: calc(var(--pos) - var(--hit) / 2);\n}\n.guide.vertical .badge {\n  top: 4px;\n  left: calc(var(--pos) + 4px);\n}\n.guide.vertical .hit,\n.guide.vertical .badge {\n  cursor: ew-resize;\n}\n.guide.horizontal .line {\n  left: 0;\n  right: 0;\n  height: 1px;\n  top: calc(var(--pos) - 0.5px);\n}\n.guide.horizontal .hit {\n  left: 0;\n  right: 0;\n  height: var(--hit);\n  top: calc(var(--pos) - var(--hit) / 2);\n}\n.guide.horizontal .badge {\n  left: 4px;\n  top: calc(var(--pos) + 4px);\n}\n.guide.horizontal .hit,\n.guide.horizontal .badge {\n  cursor: ns-resize;\n}\n.line {\n  position: absolute;\n  background: var(--color);\n}\n/* Wider invisible strip along the line, so it's easy to grab. */\n.hit {\n  position: absolute;\n  pointer-events: auto;\n  touch-action: none;\n}\n.badge {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 2px 2px 6px;\n  background: var(--color);\n  color: #fff;\n  pointer-events: auto;\n  touch-action: none;\n  user-select: none;\n}\n.badge .icon {\n  padding: 1px 5px;\n}\n/* The element a drag is currently snapped to. */\n.snapTarget {\n  position: absolute;\n  outline: 1px dashed #22c55e;\n  pointer-events: none;\n}\n/* Dashed line between two parallel guides (the width of one side is set inline). */\n.distance {\n  position: absolute;\n  border: 0 dashed #ff2d9b;\n}\n/* ── Alignment ──────────────────────────────────────── */\n.outline {\n  position: absolute;\n  outline: 1px solid #22c55e;\n  background: rgba(34, 197, 94, 0.08);\n}\n.outline.nearMiss {\n  outline-color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n.label.nearMiss {\n  padding: 1px 4px;\n  background: #ef4444;\n  color: #fff;\n}\n/* ── Wrap element ───────────────────────────────────── */\n.preview {\n  position: absolute;\n  display: none;\n  outline: 1px dashed #a855f7;\n  background: rgba(168, 85, 247, 0.08);\n}\n.label.banner {\n  display: none;\n  top: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 6px 10px;\n  background: #a855f7;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PupJHrr1baeo8RAS43rK`,
	"layer": `gsRFg2sqw_JginY7NJm5`,
	"label": `VmSJmXF0BXmnm6KBa0K2`,
	"icon": `irW8vUrs8dGoupUjjuDY`,
	"ruler": `J5s8ld23dhszPqM5B4Bp`,
	"snapped": `hHDqP2PuHhH7D_1f2Wqp`,
	"selected": `QVbg_ANmub302CvsqmMV`,
	"toolbar": `Ow3Zt9_8rgicyPwVqTyl`,
	"readout": `aK1xXF5pIjwxuHtnKm7m`,
	"marker": `owjDYfn0Qwnw0sc1U4oc`,
	"grip": `lUKSn8H_yTEFQYHdjv98`,
	"horizontal": `nQQKDucHzj9arggHu5G6`,
	"vertical": `iJQRqoFYcwMGmxIjrEQ1`,
	"guide": `v6QKX1LFfHe8YUQU8Mit`,
	"wrap": `uFMBHgfriC3qM3u2yMcd`,
	"badge": `L4ztHnerdSVin63hm73G`,
	"line": `LK9ZX5dd7Zvsx329DPcz`,
	"hit": `AhNYJ1JRK19McDKdcMUJ`,
	"snapTarget": `sAygrgj8Daa9wqEm3qmV`,
	"distance": `NrCVGtHQJ3FVdxHbXoTl`,
	"outline": `yRL82t8HB2kYAjgLgpF2`,
	"nearMiss": `K2iP9598U13usSC8tsyt`,
	"preview": `IBe3QC1B0Cm9WHpC3zQq`,
	"banner": `FtqOHNz1D0yuX9dDydaW`
};
export default ___CSS_LOADER_EXPORT___;
